import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, withCtx as _withCtx, Fragment as _Fragment, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-c04ab756"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "wrapper-inner" }
const _hoisted_2 = { class: "content-wrapper" }
const _hoisted_3 = { class: "mt-4" }
const _hoisted_4 = ["innerHTML"]
const _hoisted_5 = ["innerHTML"]

import { useRoute } from 'vue-router'
import { ref, onMounted } from 'vue'

import { useGlobals } from '@/popup/compositions/useGlobals'
import TestnetBackground from '@/assets/testnet-welcome.png'
import { InternalMethods } from '@/shared/apis/messages'
import { NetworkInfoDBSchema } from '@/shared/Database/UPSettings/models'
import SvgIcon from '@/popup/components/shared/SvgIcon.vue'
import IconButton from '@/popup/components/shared/IconButton.vue'
import NetworkChangeConfirmation from '@/popup/components/Modal/NetworkChangeConfirmation.vue'
import NetworkSwitchWrapper from '@/popup/components/shared/NetworkSwitchWrapper.vue'
import { useAppStore } from '@/popup/store/AppStore'
import NetworkSelect from '@/popup/components/Modal/NetworkSelect.vue'
import ModalTransition from '@/popup/components/shared/Modal/ModalTransition.vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'BaseSupport',
  setup(__props) {

const route = useRoute()
const appStore = useAppStore()
const currentNetworkId = ref(appStore.network.id)
const isNetworkListOpen = ref(false)
const nonEmptyNetworks = ref<NetworkInfoDBSchema[]>([])

const from = route.query['from'] as string

const toggleNetworkListView = () => {
  isNetworkListOpen.value = !isNetworkListOpen.value
}

const onNetworkSwitch = async (networkId: string) => {
  if (currentNetworkId.value !== networkId) {
    isNetworkListOpen.value = false
    currentNetworkId.value = networkId
    await fetchNetworks()
  }
}

const fetchNetworks = async () => {
  nonEmptyNetworks.value = await useGlobals().sendMessage({
    method: InternalMethods.GET_NETWORKS,
    payload: undefined,
  })
}

onMounted(async () => {
  await fetchNetworks()
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("section", {
      class: "base-wrapper scrollbar-wrapper px-6",
      ref: "contentRef",
      style: _normalizeStyle({
      backgroundImage: `url(${_unref(TestnetBackground)})`,
      width: 'inherit',
      backgroundRepeat: 'no-repeat',
      backgroundSize: 'contain',
    })
    }, [
      _createVNode(IconButton, {
        name: "switch",
        "data-testid": "network-switch-button",
        onOnClick: _cache[0] || (_cache[0] = ($event: any) => (toggleNetworkListView())),
        class: "hanging-btn mt-5"
      }),
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          (_unref(appStore).network.id === 'base-mainnet')
            ? (_openBlock(), _createBlock(SvgIcon, {
                key: 0,
                name: "base-icon",
                color: "#0052FF",
                width: "69.4",
                height: "69.4"
              }))
            : (_openBlock(), _createBlock(SvgIcon, {
                key: 1,
                name: "base-icon",
                color: "#0A0B0D",
                width: "69.4",
                height: "69.4"
              })),
          _createElementVNode("h1", _hoisted_3, _toDisplayString(_ctx.$t('create_new_account.base_support.title', {
              networkName: _unref(appStore).network?.name,
            })), 1 /* TEXT */),
          _createElementVNode("p", {
            class: "mt-4",
            innerHTML: 
            _ctx.$t('create_new_account.base_support.announce', {
              networkName: _unref(appStore).network?.name,
            })
          
          }, null, 8 /* PROPS */, _hoisted_4),
          _createElementVNode("p", {
            class: "mt-4",
            innerHTML: _ctx.$t('create_new_account.base_support.announce2')
          }, null, 8 /* PROPS */, _hoisted_5)
        ])
      ])
    ], 4 /* STYLE */),
    _createVNode(ModalTransition, null, {
      default: _withCtx(() => [
        (
        !_unref(appStore).state.hasDisplayedNetworkSwitchInfo && _unref(from) === 'settings'
      )
          ? (_openBlock(), _createBlock(NetworkChangeConfirmation, { key: 0 }))
          : _createCommentVNode("v-if", true)
      ]),
      _: 1 /* STABLE */
    }),
    _createVNode(ModalTransition, null, {
      default: _withCtx(() => [
        (isNetworkListOpen.value)
          ? (_openBlock(), _createBlock(NetworkSelect, {
              key: 0,
              onOnBackgroundClick: toggleNetworkListView,
              onOnNetworkSwitch: onNetworkSwitch
            }))
          : _createCommentVNode("v-if", true)
      ]),
      _: 1 /* STABLE */
    }),
    _createVNode(NetworkSwitchWrapper)
  ], 64 /* STABLE_FRAGMENT */))
}
}

})